import * as PropTypes from 'prop-types';
import Button from '../../../../baseComponents/gui/button/Button';
import Background from '../Background/Background';
import Backlight from '../Backlight/Backlight';
import Image from '../Image/Image';
import IconItem from '../IconItem/IconItem';
import Price from '../Price/Price';
import Charm from '../Charm/Charm';
import Count from '../Count/Count';
import Factor from '../Factor/Factor';
import Toggle from '../Toggle/Toggle';
import IsNew from '../IsNew/IsNew';
import Text from '../Text/Text';
import Icon from '../Icon/Icon';
import useButtonClassName from '../../model/hooks/useButtonClassName';
import { useButtonControls } from '../../model/hooks/useButtonControls';
import Beauties from '../Beauties/Beauties';
import Gifts from '../Gifts/Gifts';

export default function CustomButton(props) {
  const {
    tag,
    onClick,
    sound,
    disposable,
    timeout,
    newFlagData,
    preventDefault,
    stopPropagation,
    customCallbacks,
    callbackKey,
    callbackOptions,
    modalData,
    clickAnimation,
    children,
    gtm,
    gtmProps,
    redirect,
    link,
    ...attr
  } = props;

  const { onClick: click, isNewFlag } = useButtonControls({
    onClick,
    timeout,
    isDisposable: disposable,
    preventDefault,
    redirect,
    stopPropagation,
    sound,
    customCallbacks,
    callbackKey,
    callbackOptions,
    modalData,
    clickAnimation,
    newFlagData,
    gtm,
    gtmProps,
    link,
  });

  return (
    <Button tag={tag} {...attr} className={useButtonClassName(props)} onClick={click}>
      <Background {...props} />
      <Backlight {...props} />
      <Image {...props} />
      <Icon {...props} />
      <Text {...props} />
      <IconItem {...props} />
      <Price {...props} />
      <Beauties {...props} />
      <Gifts {...props} />
      <Charm {...props} />
      <Count {...props} />
      <Factor {...props} />
      <Toggle {...props} />
      <IsNew {...props} isNewFlag={isNewFlag} />
      {children}
    </Button>
  );
}

CustomButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
